import React from 'react'
import { useTranslation } from 'react-i18next'

import { JOB_STATUS } from 'src/constants'
import { cn } from 'src/lib/cn'
import { relativeTime, taskDuration } from 'src/utils/time'

import WorkerAvatar from '../../worker-avatar'

export type TaskStateType = {
    id?:string
    task_state: string
    scan_time: string
    modified_date: string
}

type Props = {
    task: TaskStateType
    locationMoniker: string
    color?: string
    worker?: WorkerPlanType
}

const TaskInfo: React.FC<Props> = ({ color, task, worker, locationMoniker }) => {

    const { t } = useTranslation()

    return (
        <div className='flex gap-1 justify-between relative'>
            <div className='flex flex-col gap-4'>
                <div>
                    <p className="text-sm"><span className='font-semibold'>Task Type:</span>  {worker?.task_type?.task_type_description}</p>
                </div>
                <div>
                    <p className="text-sm "><span className='font-semibold'>Task No:</span>{worker?.task_sequence}</p>
                </div>
                <div>
                    <p className="text-sm "><span className='font-semibold'>Location Moniker:</span> {locationMoniker}</p>
                </div>
                <div>
                    <p className="text-sm font-semibold"><span>Task Status:</span>
                        <span className={cn('rounded-md p-1 px-3 bg-neutral-100',
                            {
                                'text-green-700': task?.task_state === JOB_STATUS.complete,
                                'bg-green-50': task?.task_state === JOB_STATUS.complete,
                                'text-orange-500': task?.task_state === JOB_STATUS.progress,
                                'bg-orange-50': task?.task_state === JOB_STATUS.progress
                            })}>
                            {task?.task_state === JOB_STATUS.complete ? 'Completed' : task?.task_state === JOB_STATUS.progress ? 'In Progress' : 'Not Started'}</span></p>
                </div>
                <div >
                    <p className="text-sm"><span className='font-semibold'> Scan In: </span> {task?.scan_time && relativeTime(task?.scan_time!)}</p>
                </div>
                <div>
                    <p className="text-sm"><span className='font-semibold'>Scan Out: </span> {task?.task_state && task?.task_state !== JOB_STATUS.progress && (relativeTime(task?.modified_date!))}</p>
                </div>
                <div>
                    <p className="text-sm"><span className='font-semibold'>Task Duration: </span> {task?.task_state && task?.task_state !== JOB_STATUS.progress
                        && (taskDuration(task?.scan_time!, task?.modified_date!))}</p></div>
                </div>
                <div className='w-32 h-24 flex absolute right-0 items-center  rounded-md' style={{ background: color }} >
                    <div className='flex flex-col justify-between h-full w-full p-2'>
                        <div className='flex justify-between text-sm'>
                            <p>{worker?.task_sequence}</p>
                            {worker?.task_start_date && <p>
                                {t('intlDateTime', {
                                    val: new Date(worker?.task_start_date), formatParams: {
                                        val: {
                                            weekday: 'short',
                                        },
                                    },
                                })}
                            </p>}
                        </div>
                        <div className='h-[40px] w-[40px] max-w-[40px] mx-auto'>
                            <WorkerAvatar workerPlan={worker!} size='large' taskStatus={task?.task_state!} />
                        </div>
                        <p className='text-sm'>{locationMoniker}</p>
                    </div>
                </div>
            </div>
    )
}

export default TaskInfo
